"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".mobile-wrap .AdWithUs .row{display:block}.mobile-wrap .AdWithUs .col-3{text-align:center;padding:15px;margin:15px 0}"];
exports.styles = styles;
